import API from '../api/api'
import Cookies from 'universal-cookie';
import { deepMerge } from '../helper'
import { getPageTranslatableResourceSections } from '../config/translatableResourceSections'

// shop/progress reports these as <section key>_progress. Derived from the registry so
// a new section needs no change here
const RESOURCE_SECTION_PROGRESS_KEYS = getPageTranslatableResourceSections('shop')
  .map(section => `${section.key}_progress`);

const resourceSectionProgresses = (source) =>
  RESOURCE_SECTION_PROGRESS_KEYS.reduce((all, key) => ({
    ...all,
    [key]: typeof source[key] === 'number' ? source[key] : 0
  }), {});

const GET_SHOP_PENDING = 'GET_SHOP_PENDING'
const GET_SHOP_RESPONSE = 'GET_SHOP_RESPONSE'
const EDIT_LANGUAGE_CHANGED = 'EDIT_LANGUAGE_CHANGED'

const GET_SHOP_PROGRESS_PENDING = 'GET_SHOP_PROGRESS_PENDING'
const GET_SHOP_PROGRESS_PROGRESS = 'GET_SHOP_PROGRESS_PROGRESS'
const GET_SHOP_PROGRESS_RESPONSE = 'GET_SHOP_PROGRESS_RESPONSE'

const GET_SHOP_SUBSCRIPTION_PENDING = 'GET_SHOP_SUBSCRIPTION_PENDING';
const GET_SHOP_SUBSCRIPTION_RESPONSE = 'GET_SHOP_SUBSCRIPTION_RESPONSE';

const SYNC_SHOP_METAFIELDS_PENDING = 'SYNC_SHOP_METAFIELDS_PENDING'
const SYNC_SHOP_METAFIELDS_PROGRESS = 'SYNC_SHOP_METAFIELDS_PROGRESS'
const SYNC_SHOP_METAFIELDS_RESPONSE = 'SYNC_SHOP_METAFIELDS_RESPONSE'
const SAVE_SHOP_METAFIELDS_PENDING = 'SAVE_SHOP_METAFIELDS_PENDING'
const SAVE_SHOP_METAFIELDS_PROGRESS = 'SAVE_SHOP_METAFIELDS_PROGRESS'
const SAVE_SHOP_METAFIELDS_RESPONSE = 'SAVE_SHOP_METAFIELDS_RESPONSE'
const SAVE_SHOP_METAFIELDS_ABORTED = 'SAVE_SHOP_METAFIELDS_ABORTED'

const ENABLE_CROSS_DOMAIN_LINKS_PENDING = 'ENABLE_CROSS_DOMAIN_LINKS_PENDING'
const ENABLE_CROSS_DOMAIN_LINKS_RESPONSE = 'ENABLE_CROSS_DOMAIN_LINKS_RESPONSE'

const DISABLE_CROSS_DOMAIN_LINKS_PENDING = 'DISABLE_CROSS_DOMAIN_LINKS_PENDING'
const DISABLE_CROSS_DOMAIN_LINKS_RESPONSE = 'DISABLE_CROSS_DOMAIN_LINKS_RESPONSE'

const SAVE_SHOP_DATA = 'SAVE_SHOP_DATA'

const ENABLE_LANGIFY_FEATURE_PENDING = 'ENABLE_LANGIFY_FEATURE_PENDING';
const ENABLE_LANGIFY_FEATURE_RESPONSE = 'ENABLE_LANGIFY_FEATURE_RESPONSE';
const DISABLE_LANGIFY_FEATURE_PENDING = 'DISABLE_LANGIFY_FEATURE_PENDING';
const DISABLE_LANGIFY_FEATURE_RESPONSE = 'DISABLE_LANGIFY_FEATURE_RESPONSE';

const UPDATE_AVAILABLE_AUTO_TRANSLATION_WORDS = 'UPDATE_AVAILABLE_AUTO_TRANSLATION_WORDS'
const RESET_ERRORS = 'RESET_ERRORS'

const cookies = new Cookies();

const initialState = {
  get_shop_pending: true,
  get_shop_progress_pending: true,
  sync_shop_metafields_pending: false,
  save_shop_metafields_pending: false,
  shop_metafields_synchronized: false,
  enable_cross_domain_links_pending: false,
  disable_cross_domain_links_pending: false,
  progress: 0,
  error: false,
  shop: {},
  metafields: [],
  ...resourceSectionProgresses({}),
  subscription: []
}

// REDUCER
export default (state = initialState, action) => {
  switch(action.type) {
    case RESET_ERRORS: {
      return {
        ...state,
        error: false,
      }
    }
    case GET_SHOP_PROGRESS_PENDING: {
      return {
        ...state,
        get_shop_progress_pending: true,
        error: false,
      }
    }
    case GET_SHOP_PROGRESS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case GET_SHOP_PROGRESS_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          ...resourceSectionProgresses(action.response),
          get_shop_progress_pending: false,
          error: false
        }
      } else {
        return {
          ...state,
          get_shop_progress_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }
    case GET_SHOP_PENDING: {
      return {
        ...state,
        get_shop_pending: true,
        error: false,
      }
    }
    case GET_SHOP_RESPONSE: {
      if(action.response.success === true) {
        let language = cookies.get('language')
        if(language) {
          action.response.edit_language = language
        } else {
          cookies.set('language', action.response.edit_language, {path: '/'})
        }

        
        // Todo: Remove this mockup when the users plan is part of the response
        //action.response.plan = 'free';

        return {
          ...state,
          get_shop_pending: false,
          error: false,
          shop: action.response,
          edit_language: action.response.edit_language
        }
      } else {
        return {
          ...state,
          get_shop_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 0,
          },
        }
      }
    }
    case EDIT_LANGUAGE_CHANGED: {
      return {
        ...state,
        // the section progresses are the old language's; unknown until shop/progress answers
        ...resourceSectionProgresses({}),
        shop: {
          ...state.shop,
          edit_language: action.language
        }
      }
    }

    case SYNC_SHOP_METAFIELDS_PENDING: {
      return {
        ...state,
        progress: 0,
        sync_shop_metafields_pending: true,
        error: false,
      }
    }
    case SYNC_SHOP_METAFIELDS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    case SYNC_SHOP_METAFIELDS_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          shop_metafields_synchronized: true,
          sync_shop_metafields_pending: false,
          metafields: action.response.metafields,
          error: false,
        }
      } else {
        return {
          ...state,
          sync_shop_metafields_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 1
          },
        }
      }
    }

    case SAVE_SHOP_METAFIELDS_PENDING: {
      return {
        ...state,
        progress: 0,
        save_shop_metafields_pending: true,
        error: false,
      }
    }
    case SAVE_SHOP_METAFIELDS_PROGRESS: {
      return  {
        ...state,
        progress: action.progress
      }
    }
    // A save dropped because the merchant left the language never answers, and nothing refires
    // it the way a switch refires the sync - so the flag it set is cleared here. Not an error:
    // the merchant asked for the interruption.
    case SAVE_SHOP_METAFIELDS_ABORTED: {
      return {
        ...state,
        progress: 0,
        save_shop_metafields_pending: false,
        error: false,
      }
    }
    case SAVE_SHOP_METAFIELDS_RESPONSE: {
      // The response echoes what was written for the language the save was issued for. The
      // abort races a response already on the wire, so it can still land after the merchant
      // selected another language - applying it then is what puts one language's text under another.
      if(action.stale === true) {
        return {
          ...state,
          save_shop_metafields_pending: false,
          error: false,
        }
      }

      let error = false
      let newMetafields = state.metafields.slice()
      action.response.forEach(response => {
        if(response.success !== true) {
          error = {
            message: action.response,
            action: action.action,
          };
          action.items.forEach(metafield => {
            newMetafields.find(x => x.id == metafield.id).target = metafield.value
          })
        } else {
          response.metafields.forEach(metafield => {
            newMetafields.find(x => x.id == metafield.id).target = metafield.target
          })
        }
      })
      return {
        ...state,
        metafields: newMetafields,
        save_shop_metafields_pending: false,
        error: error
      }
    }

    case UPDATE_AVAILABLE_AUTO_TRANSLATION_WORDS: {
      return {
        ...state,
        shop: {
          ...state.shop,
          auto_translations: {
            ...state.shop.auto_translations,
            total_used_words: action.totalUsedWords,
            available_words: action.availableWords
          }
        }
      }
    }

    case ENABLE_CROSS_DOMAIN_LINKS_PENDING: {
      return {
        ...state,
        progress: 0,
        enable_cross_domain_links_pending: true,
        error: false,
      }
    }
    case ENABLE_CROSS_DOMAIN_LINKS_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          enable_cross_domain_links_pending: false,
          error: false,
          shop: {
            ...state.shop,
            cross_domain_links_enabled: action.response.cross_domain_links_enabled
          }
        }
      } else {
        return {
          ...state,
          enable_cross_domain_links_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 1
          },
        }
      }
    }
    case DISABLE_CROSS_DOMAIN_LINKS_PENDING: {
      return {
        ...state,
        progress: 0,
        disable_cross_domain_links_pending: true,
        error: false,
      }
    }
    case DISABLE_CROSS_DOMAIN_LINKS_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          disable_cross_domain_links_pending: false,
          error: false,
          shop: {
            ...state.shop,
            cross_domain_links_enabled: action.response.cross_domain_links_enabled
          }
        }
      } else {
        return {
          ...state,
          disable_cross_domain_links_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 1
          },
        }
      }
    }
    case SAVE_SHOP_DATA: {
      let shop = deepMerge(state.shop,action.shop);
      return {
        ...state,
        shop: shop
      }
    }

    case ENABLE_LANGIFY_FEATURE_PENDING: {
      console.log(state)
      let shop = {...state.shop};
      let newFeatures = shop.langify_features.slice();
      let feature = newFeatures.find(x => x.name === action.featureName);
      console.log(feature)
      if(feature) {
        feature.is_enabled = true;
        shop.langify_features = newFeatures;
        return {
          ...state,
          shop: shop
        }
      } else {
        return state
      }
    }
    case DISABLE_LANGIFY_FEATURE_PENDING: {
      let shop = {...state.shop};
      let newFeatures = shop.langify_features.slice();
      let feature = newFeatures.find(x => x.name === action.featureName);
      console.log(feature)
      if(feature) {
        feature.is_enabled = false;
        shop.langify_features = newFeatures;
        return {
          ...state,
          shop: shop
        }
      } else {
        return state
      }
    }


    case GET_SHOP_SUBSCRIPTION_PENDING: {
      return {
        ...state,
        get_shop_subscription_pending: true,
        error: false,
      }
    }
    case GET_SHOP_SUBSCRIPTION_RESPONSE: {
      if(action.response.success === true) {
        return {
          ...state,
          get_shop_subscription_pending: false,
          error: false,
          subscription: action.response.subscriptionData
        }
      } else {
        return {
          ...state,
          get_shop_subscription_pending: false,
          error: {
            message: action.response,
            action: action.action,
            level: 1
          },
        }
      }
    }

    default:
      return state
  }
}

// ACTIONS
export const resetErrors = () => {
  return dispatch => {
    dispatch({
      type: RESET_ERRORS
    });
  }
}

export const getShopProgress = (language) => {  
  return dispatch => {
    dispatch({
      type: GET_SHOP_PROGRESS_PENDING
    })

    API.getShopProgress(
      language,
      progress => {
        dispatch({
          type: GET_SHOP_PROGRESS_PROGRESS,
          progress: progress
        })
      },
      response => {
        // A dropped get is not dispatched at all: the switch that dropped it has already started
        // the get for the language now on screen, and that one owns the pending flag.
        if(response && response.aborted === true) {
          return;
        }

        dispatch({
          type: GET_SHOP_PROGRESS_RESPONSE,
          response: response
        }
      )
    })
  }
}

export const getShop = () => {  
  return dispatch => {
    dispatch({
      type: GET_SHOP_PENDING
    })

    API.getShop(response => {
      dispatch({
        type: GET_SHOP_RESPONSE,
        response: response
      })
    })
  }
}

export const setEditLanguage = (language) => {
  return (dispatch, getState) => {
    // The requests declared for the language being left are dropped here. Their answers carry
    // that language's text, and it is the answer landing in the new context - not the write
    // itself - that puts one language's translations under another.
    API.abortScope({language: getState().shop.shop.edit_language})

    cookies.set('language', language, {path: '/'})

    dispatch({
      type: EDIT_LANGUAGE_CHANGED,
      language: language
    })
  }
}

export const logout = (language) => {
  return dispatch => {
    API.logout(
      response => {
        if(response.success === true) {
          if(response.redirect_uri) {
            window.location.replace(response.redirect_uri);
          } else {
            window.location.replace('https://lp.langify-app.com')
          }
        }
      }
    )
  }
}

export const syncMetafields = (language) => {  
  return dispatch => {
    dispatch({
      type: SYNC_SHOP_METAFIELDS_PENDING
    })

    API.syncShopMetafields(
      language,
      progress => {
        dispatch({
          type: SYNC_SHOP_METAFIELDS_PROGRESS,
          progress: progress
        })
      },
      response => {
        // A dropped sync is not dispatched at all: the switch that dropped it has already
        // started the sync for the language now on screen, and that one owns the pending flag.
        if(response && response.aborted === true) {
          return;
        }

        dispatch({
          type: SYNC_SHOP_METAFIELDS_RESPONSE,
          response: response,
          action: () => syncMetafields(language)
        }
      )
    })
  }
}

export const saveMetafields = (language, items) => {  
  return (dispatch, getState) => {
    dispatch({
      type: SAVE_SHOP_METAFIELDS_PENDING
    })

    API.saveShopMetafields(
      language,
      items,
      progress => {
        dispatch({
          type: SAVE_SHOP_METAFIELDS_PROGRESS,
          progress: progress
        })
      },
      response => {
        if(response && response.aborted === true) {
          dispatch({
            type: SAVE_SHOP_METAFIELDS_ABORTED
          })
          return;
        }

        dispatch({
          type: SAVE_SHOP_METAFIELDS_RESPONSE,
          response: response,
          items: items,
          stale: getState().shop.shop.edit_language !== language,
          action: () => saveMetafields(language, items)
        }
      )
    })
  }
}

/**
 * Refreshes only the word balance. getShop() replaces the whole shop object,
 * re-rendering everything that hangs off it - looks like a page reload.
 */
export const refreshAvailableWords = () => {
  return dispatch => {
    API.getShop(response => {
      if(!response || !response.auto_translations) return;

      dispatch({
        type: UPDATE_AVAILABLE_AUTO_TRANSLATION_WORDS,
        totalUsedWords: response.auto_translations.total_used_words,
        availableWords: response.auto_translations.available_words
      })
    })
  }
}

export const updateAutoTranslations = (totalUsedWords, availableWords) => {
  return dispatch => {
    dispatch({
      type: UPDATE_AVAILABLE_AUTO_TRANSLATION_WORDS,
      totalUsedWords: totalUsedWords,
      availableWords: availableWords
    })
  }
}

export const enableCrossDomainLinks = () => {  
  return dispatch => {
    dispatch({
      type: ENABLE_CROSS_DOMAIN_LINKS_PENDING
    })

    API.enableCrossDomainLinks(
      response => {
        dispatch({
          type: ENABLE_CROSS_DOMAIN_LINKS_RESPONSE,
          response: response,
          action: () => enableCrossDomainLinks()
        }
      )
    })
  }
}

export const disableCrossDomainLinks = () => {  
  return dispatch => {
    dispatch({
      type: DISABLE_CROSS_DOMAIN_LINKS_PENDING
    })

    API.disableCrossDomainLinks(
      response => {
        dispatch({
          type: DISABLE_CROSS_DOMAIN_LINKS_RESPONSE,
          response: response,
          action: () => disableCrossDomainLinks()
        }
      )
    })
  }
}

export const saveShop = (shop) => {
  return dispatch => {
    dispatch({
      type: SAVE_SHOP_DATA,
      shop: shop
    })
  }
}



export const getShopSubscription = () => {  
  return dispatch => {
    dispatch({
      type: GET_SHOP_SUBSCRIPTION_PENDING
    })

    API.getShopSubscription(
      response => {
        dispatch({
          type: GET_SHOP_SUBSCRIPTION_RESPONSE,
          response: response,
          action: () => getShopSubscription()
        }
      )
    })
  }
}

export const enableLangifyFeature = (featureName, callback) => {  
  return dispatch => {
    dispatch({
      type: ENABLE_LANGIFY_FEATURE_PENDING,
      featureName: featureName
    })

    API.enableLangifyFeature(
      featureName,
      response => {
        dispatch({
          type: ENABLE_LANGIFY_FEATURE_RESPONSE,
          response: response,
          action: () => enableCrossDomainLinks(featureName, callback)
        }
      )
    })
  }
}

export const disableLangifyFeature = (featureName, callback) => {  
  return dispatch => {
    dispatch({
      type: DISABLE_LANGIFY_FEATURE_PENDING,
      featureName: featureName
    })

    API.disableLangifyFeature(
      featureName,
      response => {
        dispatch({
          type: DISABLE_LANGIFY_FEATURE_RESPONSE,
          response: response,
          action: () => disableLangifyFeature(featureName, callback)
        }
      )
    })
  }
}

